export enum MediaTypeConstant {
  EXCEL = 'application/vnd.ms-excel',
  XML = 'application/xml',
  PDF = 'application/pdf',
  OCT = 'application/octet-stream',
  TXT = 'application/text/plain',
}
